/* @HEADER
 * @version 0.16.1157 | 2026-08-16
 * @purpose Bounded data-testid registry for the "new version available" prompt (ZVX-DEV-3675).
 * @sidecar pwa-update.testids.ts.header.md
 * @layer app | @hex _none_ | @ctx _none_
 * @public true
 * @edit careful
 */

/* SpecRefs: ZVX-DEV-3675, ZVX-DEV-3747, ZVX-DEV-4223 */

export const PWA_UPDATE_TESTIDS = {
  /** Root of the fixed-corner prompt — present only while an update is waiting. */
  notice: 'pwa-update-notice',
  /** The InlineNotice instance rendering the "new version available" text. */
  message: 'pwa-update-message',
  /** Applies the waiting worker and reloads once it takes control. */
  applyButton: 'pwa-update-apply-button',
  /** Secondary "Не сейчас"/"Not now" action — dismisses without applying (ZVX-DEV-3747). */
  dismissButton: 'pwa-update-dismiss-button',
  /** The line saying what the click will do, and what stays true if it fails (ZVX-DEV-4223). */
  hint: 'pwa-update-hint',
  /** Indeterminate progress bar — present only while an apply attempt is in flight (ZVX-DEV-4223). */
  progress: 'pwa-update-progress',
} as const;
